/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as QueuesRouteImport } from './routes/queues/route'
import { Route as IndexImport } from './routes/index'
import { Route as UsefulLinksIndexImport } from './routes/useful-links/index'
import { Route as ShopIndexImport } from './routes/shop/index'
import { Route as PhoneBookIndexImport } from './routes/phone-book/index'
import { Route as OldIndexImport } from './routes/old/index'
import { Route as GroupChargeIndexImport } from './routes/group-charge/index'
import { Route as CardChargeIndexImport } from './routes/card-charge/index'
import { Route as WalletExtraIndexImport } from './routes/wallet/extra/index'
import { Route as SupportTicketsIndexImport } from './routes/support/tickets/index'
import { Route as ShopOrdersIndexImport } from './routes/shop/orders/index'
import { Route as ShopLogisticIndexImport } from './routes/shop/logistic/index'
import { Route as ShopCheckoutIndexImport } from './routes/shop/checkout/index'
import { Route as ShopCartIndexImport } from './routes/shop/cart/index'
import { Route as ProfileUpdateIndexImport } from './routes/profile/update/index'
import { Route as ProfileCompleteIndexImport } from './routes/profile/complete/index'
import { Route as PointHistoryIndexImport } from './routes/point/history/index'
import { Route as PhoneBookImportIndexImport } from './routes/phone-book/import/index'
import { Route as PhoneBookCreateIndexImport } from './routes/phone-book/create/index'
import { Route as PhoneBookIdIndexImport } from './routes/phone-book/$id/index'
import { Route as PaymentBankIndexImport } from './routes/payment/bank/index'
import { Route as OperatorStatusIndexImport } from './routes/operator/status/index'
import { Route as ClientTransactionsIndexImport } from './routes/client/transactions/index'
import { Route as ClientTokensIndexImport } from './routes/client/tokens/index'
import { Route as ClientSettingsIndexImport } from './routes/client/settings/index'
import { Route as ClientProductsIndexImport } from './routes/client/products/index'
import { Route as ClientPrizesIndexImport } from './routes/client/prizes/index'
import { Route as ClientPaymentIndexImport } from './routes/client/payment/index'
import { Route as ClientInquiryIndexImport } from './routes/client/inquiry/index'
import { Route as ClientDailyIndexImport } from './routes/client/daily/index'
import { Route as CardChargeSearchIndexImport } from './routes/card-charge/search/index'
import { Route as WalletExtraIdImport } from './routes/wallet/extra/$id'
import { Route as SupportTicketsIdImport } from './routes/support/tickets/$id'
import { Route as SupportTicketsCreateIndexImport } from './routes/support/tickets/create/index'
import { Route as ShopPaymentVerifyIndexImport } from './routes/shop/payment/verify/index'
import { Route as ClientSettingsSecurityIndexImport } from './routes/client/settings/security/index'
import { Route as ClientSaleReportIndexImport } from './routes/client/sale/report/index'
import { Route as ClientPrizesHistoryIndexImport } from './routes/client/prizes/history/index'
import { Route as ShopCategoriesIdAddressIndexImport } from './routes/shop/categories/$id/$address/index'
import { Route as ClientSaleReportChartsIndexImport } from './routes/client/sale/report/charts/index'
import { Route as iddatesecrectSentryTestIndexImport } from './routes/[id]/[date]/[secrect]/sentry/test/index'

// Create/Update Routes

const QueuesRouteRoute = QueuesRouteImport.update({
  id: '/queues',
  path: '/queues',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const UsefulLinksIndexRoute = UsefulLinksIndexImport.update({
  id: '/useful-links/',
  path: '/useful-links/',
  getParentRoute: () => rootRoute,
} as any)

const ShopIndexRoute = ShopIndexImport.update({
  id: '/shop/',
  path: '/shop/',
  getParentRoute: () => rootRoute,
} as any)

const PhoneBookIndexRoute = PhoneBookIndexImport.update({
  id: '/phone-book/',
  path: '/phone-book/',
  getParentRoute: () => rootRoute,
} as any)

const OldIndexRoute = OldIndexImport.update({
  id: '/old/',
  path: '/old/',
  getParentRoute: () => rootRoute,
} as any)

const GroupChargeIndexRoute = GroupChargeIndexImport.update({
  id: '/group-charge/',
  path: '/group-charge/',
  getParentRoute: () => rootRoute,
} as any)

const CardChargeIndexRoute = CardChargeIndexImport.update({
  id: '/card-charge/',
  path: '/card-charge/',
  getParentRoute: () => rootRoute,
} as any)

const WalletExtraIndexRoute = WalletExtraIndexImport.update({
  id: '/wallet/extra/',
  path: '/wallet/extra/',
  getParentRoute: () => rootRoute,
} as any)

const SupportTicketsIndexRoute = SupportTicketsIndexImport.update({
  id: '/support/tickets/',
  path: '/support/tickets/',
  getParentRoute: () => rootRoute,
} as any)

const ShopOrdersIndexRoute = ShopOrdersIndexImport.update({
  id: '/shop/orders/',
  path: '/shop/orders/',
  getParentRoute: () => rootRoute,
} as any)

const ShopLogisticIndexRoute = ShopLogisticIndexImport.update({
  id: '/shop/logistic/',
  path: '/shop/logistic/',
  getParentRoute: () => rootRoute,
} as any)

const ShopCheckoutIndexRoute = ShopCheckoutIndexImport.update({
  id: '/shop/checkout/',
  path: '/shop/checkout/',
  getParentRoute: () => rootRoute,
} as any)

const ShopCartIndexRoute = ShopCartIndexImport.update({
  id: '/shop/cart/',
  path: '/shop/cart/',
  getParentRoute: () => rootRoute,
} as any)

const ProfileUpdateIndexRoute = ProfileUpdateIndexImport.update({
  id: '/profile/update/',
  path: '/profile/update/',
  getParentRoute: () => rootRoute,
} as any)

const ProfileCompleteIndexRoute = ProfileCompleteIndexImport.update({
  id: '/profile/complete/',
  path: '/profile/complete/',
  getParentRoute: () => rootRoute,
} as any)

const PointHistoryIndexRoute = PointHistoryIndexImport.update({
  id: '/point/history/',
  path: '/point/history/',
  getParentRoute: () => rootRoute,
} as any)

const PhoneBookImportIndexRoute = PhoneBookImportIndexImport.update({
  id: '/phone-book/import/',
  path: '/phone-book/import/',
  getParentRoute: () => rootRoute,
} as any)

const PhoneBookCreateIndexRoute = PhoneBookCreateIndexImport.update({
  id: '/phone-book/create/',
  path: '/phone-book/create/',
  getParentRoute: () => rootRoute,
} as any)

const PhoneBookIdIndexRoute = PhoneBookIdIndexImport.update({
  id: '/phone-book/$id/',
  path: '/phone-book/$id/',
  getParentRoute: () => rootRoute,
} as any)

const PaymentBankIndexRoute = PaymentBankIndexImport.update({
  id: '/payment/bank/',
  path: '/payment/bank/',
  getParentRoute: () => rootRoute,
} as any)

const OperatorStatusIndexRoute = OperatorStatusIndexImport.update({
  id: '/operator/status/',
  path: '/operator/status/',
  getParentRoute: () => rootRoute,
} as any)

const ClientTransactionsIndexRoute = ClientTransactionsIndexImport.update({
  id: '/client/transactions/',
  path: '/client/transactions/',
  getParentRoute: () => rootRoute,
} as any)

const ClientTokensIndexRoute = ClientTokensIndexImport.update({
  id: '/client/tokens/',
  path: '/client/tokens/',
  getParentRoute: () => rootRoute,
} as any)

const ClientSettingsIndexRoute = ClientSettingsIndexImport.update({
  id: '/client/settings/',
  path: '/client/settings/',
  getParentRoute: () => rootRoute,
} as any)

const ClientProductsIndexRoute = ClientProductsIndexImport.update({
  id: '/client/products/',
  path: '/client/products/',
  getParentRoute: () => rootRoute,
} as any)

const ClientPrizesIndexRoute = ClientPrizesIndexImport.update({
  id: '/client/prizes/',
  path: '/client/prizes/',
  getParentRoute: () => rootRoute,
} as any)

const ClientPaymentIndexRoute = ClientPaymentIndexImport.update({
  id: '/client/payment/',
  path: '/client/payment/',
  getParentRoute: () => rootRoute,
} as any)

const ClientInquiryIndexRoute = ClientInquiryIndexImport.update({
  id: '/client/inquiry/',
  path: '/client/inquiry/',
  getParentRoute: () => rootRoute,
} as any)

const ClientDailyIndexRoute = ClientDailyIndexImport.update({
  id: '/client/daily/',
  path: '/client/daily/',
  getParentRoute: () => rootRoute,
} as any)

const CardChargeSearchIndexRoute = CardChargeSearchIndexImport.update({
  id: '/card-charge/search/',
  path: '/card-charge/search/',
  getParentRoute: () => rootRoute,
} as any)

const WalletExtraIdRoute = WalletExtraIdImport.update({
  id: '/wallet/extra/$id',
  path: '/wallet/extra/$id',
  getParentRoute: () => rootRoute,
} as any)

const SupportTicketsIdRoute = SupportTicketsIdImport.update({
  id: '/support/tickets/$id',
  path: '/support/tickets/$id',
  getParentRoute: () => rootRoute,
} as any)

const SupportTicketsCreateIndexRoute = SupportTicketsCreateIndexImport.update({
  id: '/support/tickets/create/',
  path: '/support/tickets/create/',
  getParentRoute: () => rootRoute,
} as any)

const ShopPaymentVerifyIndexRoute = ShopPaymentVerifyIndexImport.update({
  id: '/shop/payment/verify/',
  path: '/shop/payment/verify/',
  getParentRoute: () => rootRoute,
} as any)

const ClientSettingsSecurityIndexRoute =
  ClientSettingsSecurityIndexImport.update({
    id: '/client/settings/security/',
    path: '/client/settings/security/',
    getParentRoute: () => rootRoute,
  } as any)

const ClientSaleReportIndexRoute = ClientSaleReportIndexImport.update({
  id: '/client/sale/report/',
  path: '/client/sale/report/',
  getParentRoute: () => rootRoute,
} as any)

const ClientPrizesHistoryIndexRoute = ClientPrizesHistoryIndexImport.update({
  id: '/client/prizes/history/',
  path: '/client/prizes/history/',
  getParentRoute: () => rootRoute,
} as any)

const ShopCategoriesIdAddressIndexRoute =
  ShopCategoriesIdAddressIndexImport.update({
    id: '/shop/categories/$id/$address/',
    path: '/shop/categories/$id/$address/',
    getParentRoute: () => rootRoute,
  } as any)

const ClientSaleReportChartsIndexRoute =
  ClientSaleReportChartsIndexImport.update({
    id: '/client/sale/report/charts/',
    path: '/client/sale/report/charts/',
    getParentRoute: () => rootRoute,
  } as any)

const iddatesecrectSentryTestIndexRoute =
  iddatesecrectSentryTestIndexImport.update({
    id: '/[id]/[date]/[secrect]/sentry/test/',
    path: '/[id]/[date]/[secrect]/sentry/test/',
    getParentRoute: () => rootRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/queues': {
      id: '/queues'
      path: '/queues'
      fullPath: '/queues'
      preLoaderRoute: typeof QueuesRouteImport
      parentRoute: typeof rootRoute
    }
    '/card-charge/': {
      id: '/card-charge/'
      path: '/card-charge'
      fullPath: '/card-charge'
      preLoaderRoute: typeof CardChargeIndexImport
      parentRoute: typeof rootRoute
    }
    '/group-charge/': {
      id: '/group-charge/'
      path: '/group-charge'
      fullPath: '/group-charge'
      preLoaderRoute: typeof GroupChargeIndexImport
      parentRoute: typeof rootRoute
    }
    '/old/': {
      id: '/old/'
      path: '/old'
      fullPath: '/old'
      preLoaderRoute: typeof OldIndexImport
      parentRoute: typeof rootRoute
    }
    '/phone-book/': {
      id: '/phone-book/'
      path: '/phone-book'
      fullPath: '/phone-book'
      preLoaderRoute: typeof PhoneBookIndexImport
      parentRoute: typeof rootRoute
    }
    '/shop/': {
      id: '/shop/'
      path: '/shop'
      fullPath: '/shop'
      preLoaderRoute: typeof ShopIndexImport
      parentRoute: typeof rootRoute
    }
    '/useful-links/': {
      id: '/useful-links/'
      path: '/useful-links'
      fullPath: '/useful-links'
      preLoaderRoute: typeof UsefulLinksIndexImport
      parentRoute: typeof rootRoute
    }
    '/support/tickets/$id': {
      id: '/support/tickets/$id'
      path: '/support/tickets/$id'
      fullPath: '/support/tickets/$id'
      preLoaderRoute: typeof SupportTicketsIdImport
      parentRoute: typeof rootRoute
    }
    '/wallet/extra/$id': {
      id: '/wallet/extra/$id'
      path: '/wallet/extra/$id'
      fullPath: '/wallet/extra/$id'
      preLoaderRoute: typeof WalletExtraIdImport
      parentRoute: typeof rootRoute
    }
    '/card-charge/search/': {
      id: '/card-charge/search/'
      path: '/card-charge/search'
      fullPath: '/card-charge/search'
      preLoaderRoute: typeof CardChargeSearchIndexImport
      parentRoute: typeof rootRoute
    }
    '/client/daily/': {
      id: '/client/daily/'
      path: '/client/daily'
      fullPath: '/client/daily'
      preLoaderRoute: typeof ClientDailyIndexImport
      parentRoute: typeof rootRoute
    }
    '/client/inquiry/': {
      id: '/client/inquiry/'
      path: '/client/inquiry'
      fullPath: '/client/inquiry'
      preLoaderRoute: typeof ClientInquiryIndexImport
      parentRoute: typeof rootRoute
    }
    '/client/payment/': {
      id: '/client/payment/'
      path: '/client/payment'
      fullPath: '/client/payment'
      preLoaderRoute: typeof ClientPaymentIndexImport
      parentRoute: typeof rootRoute
    }
    '/client/prizes/': {
      id: '/client/prizes/'
      path: '/client/prizes'
      fullPath: '/client/prizes'
      preLoaderRoute: typeof ClientPrizesIndexImport
      parentRoute: typeof rootRoute
    }
    '/client/products/': {
      id: '/client/products/'
      path: '/client/products'
      fullPath: '/client/products'
      preLoaderRoute: typeof ClientProductsIndexImport
      parentRoute: typeof rootRoute
    }
    '/client/settings/': {
      id: '/client/settings/'
      path: '/client/settings'
      fullPath: '/client/settings'
      preLoaderRoute: typeof ClientSettingsIndexImport
      parentRoute: typeof rootRoute
    }
    '/client/tokens/': {
      id: '/client/tokens/'
      path: '/client/tokens'
      fullPath: '/client/tokens'
      preLoaderRoute: typeof ClientTokensIndexImport
      parentRoute: typeof rootRoute
    }
    '/client/transactions/': {
      id: '/client/transactions/'
      path: '/client/transactions'
      fullPath: '/client/transactions'
      preLoaderRoute: typeof ClientTransactionsIndexImport
      parentRoute: typeof rootRoute
    }
    '/operator/status/': {
      id: '/operator/status/'
      path: '/operator/status'
      fullPath: '/operator/status'
      preLoaderRoute: typeof OperatorStatusIndexImport
      parentRoute: typeof rootRoute
    }
    '/payment/bank/': {
      id: '/payment/bank/'
      path: '/payment/bank'
      fullPath: '/payment/bank'
      preLoaderRoute: typeof PaymentBankIndexImport
      parentRoute: typeof rootRoute
    }
    '/phone-book/$id/': {
      id: '/phone-book/$id/'
      path: '/phone-book/$id'
      fullPath: '/phone-book/$id'
      preLoaderRoute: typeof PhoneBookIdIndexImport
      parentRoute: typeof rootRoute
    }
    '/phone-book/create/': {
      id: '/phone-book/create/'
      path: '/phone-book/create'
      fullPath: '/phone-book/create'
      preLoaderRoute: typeof PhoneBookCreateIndexImport
      parentRoute: typeof rootRoute
    }
    '/phone-book/import/': {
      id: '/phone-book/import/'
      path: '/phone-book/import'
      fullPath: '/phone-book/import'
      preLoaderRoute: typeof PhoneBookImportIndexImport
      parentRoute: typeof rootRoute
    }
    '/point/history/': {
      id: '/point/history/'
      path: '/point/history'
      fullPath: '/point/history'
      preLoaderRoute: typeof PointHistoryIndexImport
      parentRoute: typeof rootRoute
    }
    '/profile/complete/': {
      id: '/profile/complete/'
      path: '/profile/complete'
      fullPath: '/profile/complete'
      preLoaderRoute: typeof ProfileCompleteIndexImport
      parentRoute: typeof rootRoute
    }
    '/profile/update/': {
      id: '/profile/update/'
      path: '/profile/update'
      fullPath: '/profile/update'
      preLoaderRoute: typeof ProfileUpdateIndexImport
      parentRoute: typeof rootRoute
    }
    '/shop/cart/': {
      id: '/shop/cart/'
      path: '/shop/cart'
      fullPath: '/shop/cart'
      preLoaderRoute: typeof ShopCartIndexImport
      parentRoute: typeof rootRoute
    }
    '/shop/checkout/': {
      id: '/shop/checkout/'
      path: '/shop/checkout'
      fullPath: '/shop/checkout'
      preLoaderRoute: typeof ShopCheckoutIndexImport
      parentRoute: typeof rootRoute
    }
    '/shop/logistic/': {
      id: '/shop/logistic/'
      path: '/shop/logistic'
      fullPath: '/shop/logistic'
      preLoaderRoute: typeof ShopLogisticIndexImport
      parentRoute: typeof rootRoute
    }
    '/shop/orders/': {
      id: '/shop/orders/'
      path: '/shop/orders'
      fullPath: '/shop/orders'
      preLoaderRoute: typeof ShopOrdersIndexImport
      parentRoute: typeof rootRoute
    }
    '/support/tickets/': {
      id: '/support/tickets/'
      path: '/support/tickets'
      fullPath: '/support/tickets'
      preLoaderRoute: typeof SupportTicketsIndexImport
      parentRoute: typeof rootRoute
    }
    '/wallet/extra/': {
      id: '/wallet/extra/'
      path: '/wallet/extra'
      fullPath: '/wallet/extra'
      preLoaderRoute: typeof WalletExtraIndexImport
      parentRoute: typeof rootRoute
    }
    '/client/prizes/history/': {
      id: '/client/prizes/history/'
      path: '/client/prizes/history'
      fullPath: '/client/prizes/history'
      preLoaderRoute: typeof ClientPrizesHistoryIndexImport
      parentRoute: typeof rootRoute
    }
    '/client/sale/report/': {
      id: '/client/sale/report/'
      path: '/client/sale/report'
      fullPath: '/client/sale/report'
      preLoaderRoute: typeof ClientSaleReportIndexImport
      parentRoute: typeof rootRoute
    }
    '/client/settings/security/': {
      id: '/client/settings/security/'
      path: '/client/settings/security'
      fullPath: '/client/settings/security'
      preLoaderRoute: typeof ClientSettingsSecurityIndexImport
      parentRoute: typeof rootRoute
    }
    '/shop/payment/verify/': {
      id: '/shop/payment/verify/'
      path: '/shop/payment/verify'
      fullPath: '/shop/payment/verify'
      preLoaderRoute: typeof ShopPaymentVerifyIndexImport
      parentRoute: typeof rootRoute
    }
    '/support/tickets/create/': {
      id: '/support/tickets/create/'
      path: '/support/tickets/create'
      fullPath: '/support/tickets/create'
      preLoaderRoute: typeof SupportTicketsCreateIndexImport
      parentRoute: typeof rootRoute
    }
    '/client/sale/report/charts/': {
      id: '/client/sale/report/charts/'
      path: '/client/sale/report/charts'
      fullPath: '/client/sale/report/charts'
      preLoaderRoute: typeof ClientSaleReportChartsIndexImport
      parentRoute: typeof rootRoute
    }
    '/shop/categories/$id/$address/': {
      id: '/shop/categories/$id/$address/'
      path: '/shop/categories/$id/$address'
      fullPath: '/shop/categories/$id/$address'
      preLoaderRoute: typeof ShopCategoriesIdAddressIndexImport
      parentRoute: typeof rootRoute
    }
    '/[id]/[date]/[secrect]/sentry/test/': {
      id: '/[id]/[date]/[secrect]/sentry/test/'
      path: '/[id]/[date]/[secrect]/sentry/test'
      fullPath: '/[id]/[date]/[secrect]/sentry/test'
      preLoaderRoute: typeof iddatesecrectSentryTestIndexImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/queues': typeof QueuesRouteRoute
  '/card-charge': typeof CardChargeIndexRoute
  '/group-charge': typeof GroupChargeIndexRoute
  '/old': typeof OldIndexRoute
  '/phone-book': typeof PhoneBookIndexRoute
  '/shop': typeof ShopIndexRoute
  '/useful-links': typeof UsefulLinksIndexRoute
  '/support/tickets/$id': typeof SupportTicketsIdRoute
  '/wallet/extra/$id': typeof WalletExtraIdRoute
  '/card-charge/search': typeof CardChargeSearchIndexRoute
  '/client/daily': typeof ClientDailyIndexRoute
  '/client/inquiry': typeof ClientInquiryIndexRoute
  '/client/payment': typeof ClientPaymentIndexRoute
  '/client/prizes': typeof ClientPrizesIndexRoute
  '/client/products': typeof ClientProductsIndexRoute
  '/client/settings': typeof ClientSettingsIndexRoute
  '/client/tokens': typeof ClientTokensIndexRoute
  '/client/transactions': typeof ClientTransactionsIndexRoute
  '/operator/status': typeof OperatorStatusIndexRoute
  '/payment/bank': typeof PaymentBankIndexRoute
  '/phone-book/$id': typeof PhoneBookIdIndexRoute
  '/phone-book/create': typeof PhoneBookCreateIndexRoute
  '/phone-book/import': typeof PhoneBookImportIndexRoute
  '/point/history': typeof PointHistoryIndexRoute
  '/profile/complete': typeof ProfileCompleteIndexRoute
  '/profile/update': typeof ProfileUpdateIndexRoute
  '/shop/cart': typeof ShopCartIndexRoute
  '/shop/checkout': typeof ShopCheckoutIndexRoute
  '/shop/logistic': typeof ShopLogisticIndexRoute
  '/shop/orders': typeof ShopOrdersIndexRoute
  '/support/tickets': typeof SupportTicketsIndexRoute
  '/wallet/extra': typeof WalletExtraIndexRoute
  '/client/prizes/history': typeof ClientPrizesHistoryIndexRoute
  '/client/sale/report': typeof ClientSaleReportIndexRoute
  '/client/settings/security': typeof ClientSettingsSecurityIndexRoute
  '/shop/payment/verify': typeof ShopPaymentVerifyIndexRoute
  '/support/tickets/create': typeof SupportTicketsCreateIndexRoute
  '/client/sale/report/charts': typeof ClientSaleReportChartsIndexRoute
  '/shop/categories/$id/$address': typeof ShopCategoriesIdAddressIndexRoute
  '/[id]/[date]/[secrect]/sentry/test': typeof iddatesecrectSentryTestIndexRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/queues': typeof QueuesRouteRoute
  '/card-charge': typeof CardChargeIndexRoute
  '/group-charge': typeof GroupChargeIndexRoute
  '/old': typeof OldIndexRoute
  '/phone-book': typeof PhoneBookIndexRoute
  '/shop': typeof ShopIndexRoute
  '/useful-links': typeof UsefulLinksIndexRoute
  '/support/tickets/$id': typeof SupportTicketsIdRoute
  '/wallet/extra/$id': typeof WalletExtraIdRoute
  '/card-charge/search': typeof CardChargeSearchIndexRoute
  '/client/daily': typeof ClientDailyIndexRoute
  '/client/inquiry': typeof ClientInquiryIndexRoute
  '/client/payment': typeof ClientPaymentIndexRoute
  '/client/prizes': typeof ClientPrizesIndexRoute
  '/client/products': typeof ClientProductsIndexRoute
  '/client/settings': typeof ClientSettingsIndexRoute
  '/client/tokens': typeof ClientTokensIndexRoute
  '/client/transactions': typeof ClientTransactionsIndexRoute
  '/operator/status': typeof OperatorStatusIndexRoute
  '/payment/bank': typeof PaymentBankIndexRoute
  '/phone-book/$id': typeof PhoneBookIdIndexRoute
  '/phone-book/create': typeof PhoneBookCreateIndexRoute
  '/phone-book/import': typeof PhoneBookImportIndexRoute
  '/point/history': typeof PointHistoryIndexRoute
  '/profile/complete': typeof ProfileCompleteIndexRoute
  '/profile/update': typeof ProfileUpdateIndexRoute
  '/shop/cart': typeof ShopCartIndexRoute
  '/shop/checkout': typeof ShopCheckoutIndexRoute
  '/shop/logistic': typeof ShopLogisticIndexRoute
  '/shop/orders': typeof ShopOrdersIndexRoute
  '/support/tickets': typeof SupportTicketsIndexRoute
  '/wallet/extra': typeof WalletExtraIndexRoute
  '/client/prizes/history': typeof ClientPrizesHistoryIndexRoute
  '/client/sale/report': typeof ClientSaleReportIndexRoute
  '/client/settings/security': typeof ClientSettingsSecurityIndexRoute
  '/shop/payment/verify': typeof ShopPaymentVerifyIndexRoute
  '/support/tickets/create': typeof SupportTicketsCreateIndexRoute
  '/client/sale/report/charts': typeof ClientSaleReportChartsIndexRoute
  '/shop/categories/$id/$address': typeof ShopCategoriesIdAddressIndexRoute
  '/[id]/[date]/[secrect]/sentry/test': typeof iddatesecrectSentryTestIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/queues': typeof QueuesRouteRoute
  '/card-charge/': typeof CardChargeIndexRoute
  '/group-charge/': typeof GroupChargeIndexRoute
  '/old/': typeof OldIndexRoute
  '/phone-book/': typeof PhoneBookIndexRoute
  '/shop/': typeof ShopIndexRoute
  '/useful-links/': typeof UsefulLinksIndexRoute
  '/support/tickets/$id': typeof SupportTicketsIdRoute
  '/wallet/extra/$id': typeof WalletExtraIdRoute
  '/card-charge/search/': typeof CardChargeSearchIndexRoute
  '/client/daily/': typeof ClientDailyIndexRoute
  '/client/inquiry/': typeof ClientInquiryIndexRoute
  '/client/payment/': typeof ClientPaymentIndexRoute
  '/client/prizes/': typeof ClientPrizesIndexRoute
  '/client/products/': typeof ClientProductsIndexRoute
  '/client/settings/': typeof ClientSettingsIndexRoute
  '/client/tokens/': typeof ClientTokensIndexRoute
  '/client/transactions/': typeof ClientTransactionsIndexRoute
  '/operator/status/': typeof OperatorStatusIndexRoute
  '/payment/bank/': typeof PaymentBankIndexRoute
  '/phone-book/$id/': typeof PhoneBookIdIndexRoute
  '/phone-book/create/': typeof PhoneBookCreateIndexRoute
  '/phone-book/import/': typeof PhoneBookImportIndexRoute
  '/point/history/': typeof PointHistoryIndexRoute
  '/profile/complete/': typeof ProfileCompleteIndexRoute
  '/profile/update/': typeof ProfileUpdateIndexRoute
  '/shop/cart/': typeof ShopCartIndexRoute
  '/shop/checkout/': typeof ShopCheckoutIndexRoute
  '/shop/logistic/': typeof ShopLogisticIndexRoute
  '/shop/orders/': typeof ShopOrdersIndexRoute
  '/support/tickets/': typeof SupportTicketsIndexRoute
  '/wallet/extra/': typeof WalletExtraIndexRoute
  '/client/prizes/history/': typeof ClientPrizesHistoryIndexRoute
  '/client/sale/report/': typeof ClientSaleReportIndexRoute
  '/client/settings/security/': typeof ClientSettingsSecurityIndexRoute
  '/shop/payment/verify/': typeof ShopPaymentVerifyIndexRoute
  '/support/tickets/create/': typeof SupportTicketsCreateIndexRoute
  '/client/sale/report/charts/': typeof ClientSaleReportChartsIndexRoute
  '/shop/categories/$id/$address/': typeof ShopCategoriesIdAddressIndexRoute
  '/[id]/[date]/[secrect]/sentry/test/': typeof iddatesecrectSentryTestIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/queues'
    | '/card-charge'
    | '/group-charge'
    | '/old'
    | '/phone-book'
    | '/shop'
    | '/useful-links'
    | '/support/tickets/$id'
    | '/wallet/extra/$id'
    | '/card-charge/search'
    | '/client/daily'
    | '/client/inquiry'
    | '/client/payment'
    | '/client/prizes'
    | '/client/products'
    | '/client/settings'
    | '/client/tokens'
    | '/client/transactions'
    | '/operator/status'
    | '/payment/bank'
    | '/phone-book/$id'
    | '/phone-book/create'
    | '/phone-book/import'
    | '/point/history'
    | '/profile/complete'
    | '/profile/update'
    | '/shop/cart'
    | '/shop/checkout'
    | '/shop/logistic'
    | '/shop/orders'
    | '/support/tickets'
    | '/wallet/extra'
    | '/client/prizes/history'
    | '/client/sale/report'
    | '/client/settings/security'
    | '/shop/payment/verify'
    | '/support/tickets/create'
    | '/client/sale/report/charts'
    | '/shop/categories/$id/$address'
    | '/[id]/[date]/[secrect]/sentry/test'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/queues'
    | '/card-charge'
    | '/group-charge'
    | '/old'
    | '/phone-book'
    | '/shop'
    | '/useful-links'
    | '/support/tickets/$id'
    | '/wallet/extra/$id'
    | '/card-charge/search'
    | '/client/daily'
    | '/client/inquiry'
    | '/client/payment'
    | '/client/prizes'
    | '/client/products'
    | '/client/settings'
    | '/client/tokens'
    | '/client/transactions'
    | '/operator/status'
    | '/payment/bank'
    | '/phone-book/$id'
    | '/phone-book/create'
    | '/phone-book/import'
    | '/point/history'
    | '/profile/complete'
    | '/profile/update'
    | '/shop/cart'
    | '/shop/checkout'
    | '/shop/logistic'
    | '/shop/orders'
    | '/support/tickets'
    | '/wallet/extra'
    | '/client/prizes/history'
    | '/client/sale/report'
    | '/client/settings/security'
    | '/shop/payment/verify'
    | '/support/tickets/create'
    | '/client/sale/report/charts'
    | '/shop/categories/$id/$address'
    | '/[id]/[date]/[secrect]/sentry/test'
  id:
    | '__root__'
    | '/'
    | '/queues'
    | '/card-charge/'
    | '/group-charge/'
    | '/old/'
    | '/phone-book/'
    | '/shop/'
    | '/useful-links/'
    | '/support/tickets/$id'
    | '/wallet/extra/$id'
    | '/card-charge/search/'
    | '/client/daily/'
    | '/client/inquiry/'
    | '/client/payment/'
    | '/client/prizes/'
    | '/client/products/'
    | '/client/settings/'
    | '/client/tokens/'
    | '/client/transactions/'
    | '/operator/status/'
    | '/payment/bank/'
    | '/phone-book/$id/'
    | '/phone-book/create/'
    | '/phone-book/import/'
    | '/point/history/'
    | '/profile/complete/'
    | '/profile/update/'
    | '/shop/cart/'
    | '/shop/checkout/'
    | '/shop/logistic/'
    | '/shop/orders/'
    | '/support/tickets/'
    | '/wallet/extra/'
    | '/client/prizes/history/'
    | '/client/sale/report/'
    | '/client/settings/security/'
    | '/shop/payment/verify/'
    | '/support/tickets/create/'
    | '/client/sale/report/charts/'
    | '/shop/categories/$id/$address/'
    | '/[id]/[date]/[secrect]/sentry/test/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  QueuesRouteRoute: typeof QueuesRouteRoute
  CardChargeIndexRoute: typeof CardChargeIndexRoute
  GroupChargeIndexRoute: typeof GroupChargeIndexRoute
  OldIndexRoute: typeof OldIndexRoute
  PhoneBookIndexRoute: typeof PhoneBookIndexRoute
  ShopIndexRoute: typeof ShopIndexRoute
  UsefulLinksIndexRoute: typeof UsefulLinksIndexRoute
  SupportTicketsIdRoute: typeof SupportTicketsIdRoute
  WalletExtraIdRoute: typeof WalletExtraIdRoute
  CardChargeSearchIndexRoute: typeof CardChargeSearchIndexRoute
  ClientDailyIndexRoute: typeof ClientDailyIndexRoute
  ClientInquiryIndexRoute: typeof ClientInquiryIndexRoute
  ClientPaymentIndexRoute: typeof ClientPaymentIndexRoute
  ClientPrizesIndexRoute: typeof ClientPrizesIndexRoute
  ClientProductsIndexRoute: typeof ClientProductsIndexRoute
  ClientSettingsIndexRoute: typeof ClientSettingsIndexRoute
  ClientTokensIndexRoute: typeof ClientTokensIndexRoute
  ClientTransactionsIndexRoute: typeof ClientTransactionsIndexRoute
  OperatorStatusIndexRoute: typeof OperatorStatusIndexRoute
  PaymentBankIndexRoute: typeof PaymentBankIndexRoute
  PhoneBookIdIndexRoute: typeof PhoneBookIdIndexRoute
  PhoneBookCreateIndexRoute: typeof PhoneBookCreateIndexRoute
  PhoneBookImportIndexRoute: typeof PhoneBookImportIndexRoute
  PointHistoryIndexRoute: typeof PointHistoryIndexRoute
  ProfileCompleteIndexRoute: typeof ProfileCompleteIndexRoute
  ProfileUpdateIndexRoute: typeof ProfileUpdateIndexRoute
  ShopCartIndexRoute: typeof ShopCartIndexRoute
  ShopCheckoutIndexRoute: typeof ShopCheckoutIndexRoute
  ShopLogisticIndexRoute: typeof ShopLogisticIndexRoute
  ShopOrdersIndexRoute: typeof ShopOrdersIndexRoute
  SupportTicketsIndexRoute: typeof SupportTicketsIndexRoute
  WalletExtraIndexRoute: typeof WalletExtraIndexRoute
  ClientPrizesHistoryIndexRoute: typeof ClientPrizesHistoryIndexRoute
  ClientSaleReportIndexRoute: typeof ClientSaleReportIndexRoute
  ClientSettingsSecurityIndexRoute: typeof ClientSettingsSecurityIndexRoute
  ShopPaymentVerifyIndexRoute: typeof ShopPaymentVerifyIndexRoute
  SupportTicketsCreateIndexRoute: typeof SupportTicketsCreateIndexRoute
  ClientSaleReportChartsIndexRoute: typeof ClientSaleReportChartsIndexRoute
  ShopCategoriesIdAddressIndexRoute: typeof ShopCategoriesIdAddressIndexRoute
  iddatesecrectSentryTestIndexRoute: typeof iddatesecrectSentryTestIndexRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  QueuesRouteRoute: QueuesRouteRoute,
  CardChargeIndexRoute: CardChargeIndexRoute,
  GroupChargeIndexRoute: GroupChargeIndexRoute,
  OldIndexRoute: OldIndexRoute,
  PhoneBookIndexRoute: PhoneBookIndexRoute,
  ShopIndexRoute: ShopIndexRoute,
  UsefulLinksIndexRoute: UsefulLinksIndexRoute,
  SupportTicketsIdRoute: SupportTicketsIdRoute,
  WalletExtraIdRoute: WalletExtraIdRoute,
  CardChargeSearchIndexRoute: CardChargeSearchIndexRoute,
  ClientDailyIndexRoute: ClientDailyIndexRoute,
  ClientInquiryIndexRoute: ClientInquiryIndexRoute,
  ClientPaymentIndexRoute: ClientPaymentIndexRoute,
  ClientPrizesIndexRoute: ClientPrizesIndexRoute,
  ClientProductsIndexRoute: ClientProductsIndexRoute,
  ClientSettingsIndexRoute: ClientSettingsIndexRoute,
  ClientTokensIndexRoute: ClientTokensIndexRoute,
  ClientTransactionsIndexRoute: ClientTransactionsIndexRoute,
  OperatorStatusIndexRoute: OperatorStatusIndexRoute,
  PaymentBankIndexRoute: PaymentBankIndexRoute,
  PhoneBookIdIndexRoute: PhoneBookIdIndexRoute,
  PhoneBookCreateIndexRoute: PhoneBookCreateIndexRoute,
  PhoneBookImportIndexRoute: PhoneBookImportIndexRoute,
  PointHistoryIndexRoute: PointHistoryIndexRoute,
  ProfileCompleteIndexRoute: ProfileCompleteIndexRoute,
  ProfileUpdateIndexRoute: ProfileUpdateIndexRoute,
  ShopCartIndexRoute: ShopCartIndexRoute,
  ShopCheckoutIndexRoute: ShopCheckoutIndexRoute,
  ShopLogisticIndexRoute: ShopLogisticIndexRoute,
  ShopOrdersIndexRoute: ShopOrdersIndexRoute,
  SupportTicketsIndexRoute: SupportTicketsIndexRoute,
  WalletExtraIndexRoute: WalletExtraIndexRoute,
  ClientPrizesHistoryIndexRoute: ClientPrizesHistoryIndexRoute,
  ClientSaleReportIndexRoute: ClientSaleReportIndexRoute,
  ClientSettingsSecurityIndexRoute: ClientSettingsSecurityIndexRoute,
  ShopPaymentVerifyIndexRoute: ShopPaymentVerifyIndexRoute,
  SupportTicketsCreateIndexRoute: SupportTicketsCreateIndexRoute,
  ClientSaleReportChartsIndexRoute: ClientSaleReportChartsIndexRoute,
  ShopCategoriesIdAddressIndexRoute: ShopCategoriesIdAddressIndexRoute,
  iddatesecrectSentryTestIndexRoute: iddatesecrectSentryTestIndexRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/queues",
        "/card-charge/",
        "/group-charge/",
        "/old/",
        "/phone-book/",
        "/shop/",
        "/useful-links/",
        "/support/tickets/$id",
        "/wallet/extra/$id",
        "/card-charge/search/",
        "/client/daily/",
        "/client/inquiry/",
        "/client/payment/",
        "/client/prizes/",
        "/client/products/",
        "/client/settings/",
        "/client/tokens/",
        "/client/transactions/",
        "/operator/status/",
        "/payment/bank/",
        "/phone-book/$id/",
        "/phone-book/create/",
        "/phone-book/import/",
        "/point/history/",
        "/profile/complete/",
        "/profile/update/",
        "/shop/cart/",
        "/shop/checkout/",
        "/shop/logistic/",
        "/shop/orders/",
        "/support/tickets/",
        "/wallet/extra/",
        "/client/prizes/history/",
        "/client/sale/report/",
        "/client/settings/security/",
        "/shop/payment/verify/",
        "/support/tickets/create/",
        "/client/sale/report/charts/",
        "/shop/categories/$id/$address/",
        "/[id]/[date]/[secrect]/sentry/test/"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/queues": {
      "filePath": "queues/route.tsx"
    },
    "/card-charge/": {
      "filePath": "card-charge/index.tsx"
    },
    "/group-charge/": {
      "filePath": "group-charge/index.tsx"
    },
    "/old/": {
      "filePath": "old/index.tsx"
    },
    "/phone-book/": {
      "filePath": "phone-book/index.tsx"
    },
    "/shop/": {
      "filePath": "shop/index.tsx"
    },
    "/useful-links/": {
      "filePath": "useful-links/index.tsx"
    },
    "/support/tickets/$id": {
      "filePath": "support/tickets/$id.tsx"
    },
    "/wallet/extra/$id": {
      "filePath": "wallet/extra/$id.tsx"
    },
    "/card-charge/search/": {
      "filePath": "card-charge/search/index.tsx"
    },
    "/client/daily/": {
      "filePath": "client/daily/index.tsx"
    },
    "/client/inquiry/": {
      "filePath": "client/inquiry/index.tsx"
    },
    "/client/payment/": {
      "filePath": "client/payment/index.tsx"
    },
    "/client/prizes/": {
      "filePath": "client/prizes/index.tsx"
    },
    "/client/products/": {
      "filePath": "client/products/index.tsx"
    },
    "/client/settings/": {
      "filePath": "client/settings/index.tsx"
    },
    "/client/tokens/": {
      "filePath": "client/tokens/index.tsx"
    },
    "/client/transactions/": {
      "filePath": "client/transactions/index.tsx"
    },
    "/operator/status/": {
      "filePath": "operator/status/index.tsx"
    },
    "/payment/bank/": {
      "filePath": "payment/bank/index.tsx"
    },
    "/phone-book/$id/": {
      "filePath": "phone-book/$id/index.tsx"
    },
    "/phone-book/create/": {
      "filePath": "phone-book/create/index.tsx"
    },
    "/phone-book/import/": {
      "filePath": "phone-book/import/index.tsx"
    },
    "/point/history/": {
      "filePath": "point/history/index.tsx"
    },
    "/profile/complete/": {
      "filePath": "profile/complete/index.tsx"
    },
    "/profile/update/": {
      "filePath": "profile/update/index.tsx"
    },
    "/shop/cart/": {
      "filePath": "shop/cart/index.tsx"
    },
    "/shop/checkout/": {
      "filePath": "shop/checkout/index.tsx"
    },
    "/shop/logistic/": {
      "filePath": "shop/logistic/index.tsx"
    },
    "/shop/orders/": {
      "filePath": "shop/orders/index.tsx"
    },
    "/support/tickets/": {
      "filePath": "support/tickets/index.tsx"
    },
    "/wallet/extra/": {
      "filePath": "wallet/extra/index.tsx"
    },
    "/client/prizes/history/": {
      "filePath": "client/prizes/history/index.tsx"
    },
    "/client/sale/report/": {
      "filePath": "client/sale/report/index.tsx"
    },
    "/client/settings/security/": {
      "filePath": "client/settings/security/index.tsx"
    },
    "/shop/payment/verify/": {
      "filePath": "shop/payment/verify/index.tsx"
    },
    "/support/tickets/create/": {
      "filePath": "support/tickets/create/index.tsx"
    },
    "/client/sale/report/charts/": {
      "filePath": "client/sale/report/charts/index.tsx"
    },
    "/shop/categories/$id/$address/": {
      "filePath": "shop/categories/$id/$address/index.tsx"
    },
    "/[id]/[date]/[secrect]/sentry/test/": {
      "filePath": "[id]/[date]/[secrect]/sentry/test/index.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
